/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-03 16:13:42
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/DropDown/DropDown.tsx
 */
import React from 'react';
import { Dropdown } from 'antd';
import css from './DropDown.less';
interface IProps {
  overlay;
  children;
  placement?;
  onVisibleChange?;
  visible?;
  className?;
  trigger?;
  overlayClassName?: string;
  maxWidth?: number;
  maxHeight?: number;
  onClick?: (e?) => void;
  onFocus?;
  onBlur?;
  getPopupContainer?;
  disabled?;
  icon?;
  overlayItemClassName?;
  overlayStyle?;
}
const DropDown = (props: IProps) => {
  const {
    overlay,
    children,
    overlayClassName,
    overlayItemClassName,
    maxWidth,
    maxHeight,

    ...rest
  } = props;
  const overlayNode = () => (
    <div
      className={`${css.overlayNodeItem} ${overlayItemClassName || ''}`}
      style={{ maxWidth: maxWidth, maxHeight: maxHeight }}>
      {overlay}
    </div>
  );
  return (
    <Dropdown
      // overlayStyle={{ width: '100%' }}
      overlay={overlayNode}
      overlayClassName={overlayClassName}
      {...rest}>
      {children}
    </Dropdown>
  );
};
DropDown.Button = (props: IProps) => {
  const {
    overlay,
    children,
    maxWidth,
    maxHeight,
    overlayItemClassName,
    ...rest
  } = props;
  const overlayNode = () => (
    <div
      className={`${css.overlayNodeItem} ${overlayItemClassName || ''}`}
      style={{ maxWidth: maxWidth, maxHeight: maxHeight }}>
      {overlay}
    </div>
  );
  return (
    <Dropdown.Button overlay={overlayNode} {...rest}>
      {children}
    </Dropdown.Button>
  );
};

export default DropDown;
